import * as api from "api/api";

export const fetchGeocode = (address?: string) => {
	return api.getGeocode(address);
};